export default __webpack_public_path__ + "static/media/unipoli-tarvikejakelu.d04ad543.svg";